module.exports = __webpack_public_path__ + "img/no_pending_expenses_illustration.91b752b3.png";